// Nearest point on a single segment to `point` (clamped projection).
function nearestPointOnSegment(point, segStart, segEnd) {
  const dx = segEnd[0] - segStart[0];
  const dy = segEnd[1] - segStart[1];
  const lengthSq = dx * dx + dy * dy;
  if (lengthSq === 0) return { x: segStart[0], y: segStart[1] };
  let t = ((point.x - segStart[0]) * dx + (point.y - segStart[1]) * dy) / lengthSq;
  t = Math.max(0, Math.min(1, t));
  return { x: segStart[0] + t * dx, y: segStart[1] + t * dy };
}

// Nearest point on a polyline (array of {start:[x,y], end:[x,y]} segments) to
// `point` ({x, y}). Used to draw a labels→pipe connection's line to a
// sensible point on the target pipe rather than nothing at all, since a
// Connection has no single fixed position the way an Element's boundingBox
// center does. See Connection.js / DrawingView.js Phase 1.5 wiring.
export function nearestPointOnPolyline(point, segments) {
  if (!point || !Array.isArray(segments) || segments.length === 0) return null;
  let best = null;
  let bestDistSq = Infinity;
  for (const seg of segments) {
    if (!seg?.start || !seg?.end) continue;
    const candidate = nearestPointOnSegment(point, seg.start, seg.end);
    const dx = candidate.x - point.x;
    const dy = candidate.y - point.y;
    const distSq = dx * dx + dy * dy;
    if (distSq < bestDistSq) {
      bestDistSq = distSq;
      best = candidate;
    }
  }
  return best;
}
